import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassRetrieve } from 'types';
import { client } from 'utils/api-client';

function useClass(kiloClassId: string | undefined): UseQueryResult<{ data: KiloClassRetrieve }> {
  return useQuery(['classes', kiloClassId], () => client.get(`kilo-classes/${kiloClassId}/`), {
    enabled: !!kiloClassId,
  });
}

export default useClass;
